import { SIGNIN, SESSIONOUT } from "./Endpoints";
import { _Post } from "./ApiMethods";

export const handlSignin = async (payload) => {
  try {
    const { data } = await _Post(SIGNIN, payload);
    return data;
  } catch (err) {
    throw err;
  }
};

export const handlSessionOut = async (payload) => {
  try {
    const { data } = await _Post(SESSIONOUT, {});
    return data;
  } catch (err) {
    throw err;
  }
};

